import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { ArrowsMain, TestQuate } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

function Pureplank(props) {
  return (
    <>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekrevol_project_item"
          >
            <div
              className="pizza_project"
              style={{ background: "rgb(33, 37, 41)" }}
            >
              <Row>
                <Col xs={12} md={8} lg={6} xl={6} xxl={6}>
                  <div className="project_info">
                    <div className="logo_project">
                      <StaticImage
                        src="../../images/Pureplank/Logo.webp"
                        alt="tekrevol_Casestudy"
                        className="img-fluid"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["png"]}
                        width={175}
                        height={90}
                      />
                    </div>
                    <div className="framework_project">
                      <ul style={{ color: "rgb(142, 240, 139)" }}>
                        <li>IOS App</li>
                        <li>Android App</li>
                        <li>Web App</li>
                      </ul>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={4} lg={6} xl={6} xxl={6}></Col>
                <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                  <div
                    className="project_title"
                    style={{ color: "rgb(255, 255, 255)" }}
                  >
                    <h2 style={{ color: "rgb(255, 255, 255)" }}>
                      The Idea Behind Pure Plank
                    </h2>
                    <div className="project_details">
                      <p>
                        Plank is an online platform for fitness and exercise
                        enthusiasts aiming to look after their health and
                        exercise at home. With video tutorials and challenges,
                        this platform brings a new idea to life. TekRevol has
                        developed several digital solutions, including mobile
                        apps, pertaining to the fitness and healthcare sector.
                      </p>
                      <p>
                        The Plank app is a complete solution surrounding the
                        planking exercise where users get all the functions and
                        features in one place to get the ideal results. The app
                        also had video tutorials and instructions for the users,
                        as well as the option to buy accessories with complete
                        payment integration options.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={6} xl={7} xxl={7}>
                  <div className="img_prev">
                    <div className="case_item">
                      <StaticImage
                        src="../../images/Pureplank/Pure-Plank.webp"
                        alt="tekrevol_Casestudy"
                        className="img-fluid"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["png"]}
                        width={1035}
                        height={842}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col
            xs={12}
            md={9}
            lg={7}
            xl={6}
            xxl={6}
            className="m-auto tekrevol_project_review"
          >
            <div className="project_review">
              <p>
                “I had the pleasure of working with TekRevol on the development
                of our fitness app, and I am extremely impressed with the level
                of service they provided. Their team was incredibly
                knowledgeable, professional, and dedicated to ensuring that our
                app was developed to the highest standard."
                {TestQuate}
              </p>
              <div className="review_info">
                <div className="preson">
                  <StaticImage
                    src="../../images/Pureplank/client_img.webp"
                    alt="tekrevol_Casestudy"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={70}
                    height={70}
                  />
                </div>
                <div className="preson_info">
                  <h6>Ari Marinovsky</h6>
                  <div className="designation">Pure Plank, CEO</div>
                  <div className="project_link">
                    <Link
                      to="/case-studies/pure-plank"
                      aria-label="TekRevol Pure-Plank"
                    >
                      Full Case Study
                      {ArrowsMain}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Pureplank;
